"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemResponse = void 0;
/**
 * It represents an attempt item response
 *
 * @property {string}        externalItemId     - unique identifier for the external item
 * @property {string}        externalBankItemId - unique identifier for the external item at the item bank
 *                                                this is linked directly to responses
 * @property {string}        responses          - list of responses within the same item
 *
 * @author javier.perez
 */
var ItemResponse = /** @class */ (function () {
    function ItemResponse(data) {
        if (data === void 0) { data = {}; }
        Object.assign(this, data);
    }
    /**
     * Only return responses with max Score > 0
     */
    ItemResponse.prototype.responsesWithScore = function () {
        return this.responses.filter(function (response) { return response.maxScore > 0; }) || [];
    };
    Object.defineProperty(ItemResponse.prototype, "isCorrect", {
        get: function () {
            var questionResponses = this.responsesWithScore();
            return questionResponses.length > 0 && questionResponses.every(function (_a) {
                var isCorrect = _a.isCorrect;
                return isCorrect;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ItemResponse.prototype, "isPartiallyCorrect", {
        get: function () {
            var questionResponses = this.responsesWithScore();
            return (questionResponses.length > 0 &&
                ((questionResponses.some(function (_a) {
                    var isCorrect = _a.isCorrect;
                    return isCorrect;
                }) &&
                    questionResponses.some(function (_a) {
                        var isCorrect = _a.isCorrect, attempted = _a.attempted;
                        return !isCorrect || !attempted;
                    })) ||
                    questionResponses.some(function (_a) {
                        var isPartiallyCorrect = _a.isPartiallyCorrect;
                        return isPartiallyCorrect;
                    })));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ItemResponse.prototype, "isIncorrect", {
        get: function () {
            var questionResponses = this.responsesWithScore();
            return (questionResponses.length > 0 &&
                questionResponses.every(function (_a) {
                    var attempted = _a.attempted, isIncorrect = _a.isIncorrect;
                    return (isIncorrect && attempted) || !attempted;
                }));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ItemResponse.prototype, "attempted", {
        get: function () {
            var _a;
            return !!((_a = this.responses) === null || _a === void 0 ? void 0 : _a.some(function (_a) {
                var attempted = _a.attempted;
                return attempted;
            }));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ItemResponse.prototype, "isQuantitativeGraded", {
        get: function () {
            var responses = this.responsesWithScore();
            return (responses.length > 0 &&
                responses
                    .filter(function (_a) {
                    var attempted = _a.attempted, maxScore = _a.maxScore;
                    return attempted && maxScore !== 0;
                })
                    .every(function (_a) {
                    var graded = _a.graded;
                    return graded;
                }));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ItemResponse.prototype, "isGraded", {
        get: function () {
            var responses = this.responses || [];
            return (responses.length > 0 &&
                responses.filter(function (_a) {
                    var attempted = _a.attempted;
                    return attempted;
                }).every(function (_a) {
                    var graded = _a.graded;
                    return graded;
                }));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ItemResponse.prototype, "isGradedNoStudentSubmission", {
        get: function () {
            var responses = this.responses || [];
            return (responses.length > 0 &&
                responses.filter(function (_a) {
                    var attempted = _a.attempted, graded = _a.graded;
                    return attempted && graded;
                }).length === responses.length);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ItemResponse.prototype, "totalScore", {
        get: function () {
            var questionResponses = this.responses || [];
            var attemptedQuestions = questionResponses.filter(function (response) { return response.attempted; });
            return attemptedQuestions.length > 0
                ? attemptedQuestions.map(function (response) { return response.score; }).reduce(function (p, c) { return p + c; })
                : 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ItemResponse.prototype, "hasMaxScoreZero", {
        get: function () {
            var questionResponses = this.responses || [];
            return questionResponses.some(function (response) { return response.maxScore === 0; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ItemResponse.prototype, "totalMaxScore", {
        get: function () {
            var questionResponses = this.responses || [];
            return questionResponses.length > 0
                ? questionResponses.map(function (response) { return response.maxScore; }).reduce(function (p, c) { return p + c; })
                : 0;
        },
        enumerable: false,
        configurable: true
    });
    ItemResponse.prototype.getQuestionResponse = function (question) {
        return (this.responses || []).find(function (response) { return response.externalQuestionId === question.externalId; });
    };
    return ItemResponse;
}());
exports.ItemResponse = ItemResponse;
